<script lang="ts">
  import Button from './Button.svelte';
  
  export let message: string = 'Something went wrong';
  export let description: string = '';
  export let onRetry: (() => void) | null = null;
</script>

<div class="error-state">
  <svg class="error-icon" viewBox="0 0 24 24" width="64" height="64" fill="none" stroke="#ef4444" stroke-width="1.5" aria-hidden="true">
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="12"/>
    <line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
  
  <h3 class="error-title">{message}</h3>
  
  {#if description}
    <p class="error-description">{description}</p>
  {/if}
  
  {#if onRetry}
    <div class="error-action">
      <Button variant="primary" on:click={onRetry}>
        Try Again
      </Button>
    </div>
  {/if}
</div>

<style>
  .error-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4rem 2rem;
    text-align: center;
    min-height: 300px;
  }

  .error-icon {
    width: 64px;
    height: 64px;
    margin-bottom: 1.5rem;
  }

  .error-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 0.5rem 0;
  }

  .error-description {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0 0 1.5rem 0;
    max-width: 400px;
  }

  .error-action {
    margin-top: 1rem;
  }
</style>

